import { useMemo } from 'react';
import { useI18n } from '../i18n';
import { getConsentCopy, getPrivacyNotice } from './privacyNotices';

/**
 * Privacy notice + consent labels for a jurisdiction, synced to app language.
 * @param {'AU'|'CO'|'ES'} jurisdiction
 */
export function usePrivacyNotice(jurisdiction) {
  const { language } = useI18n();

  return useMemo(
    () => ({
      notice: getPrivacyNotice(jurisdiction, language),
      consent: getConsentCopy(jurisdiction, language),
      language,
    }),
    [jurisdiction, language],
  );
}
